export const POST_AUTH_REDIRECT = 'postAuthRedirect';

const DEFAULT_REDIRECT = '/conversation-type';
const REDIRECT_TTL_MS = 30 * 60 * 1000;
const AUTH_ONLY_PATHS = new Set([
  '/auth',
  '/forgot-password',
  '/reset-password',
]);

export function normalizeInternalRedirect(value) {
  const candidate = typeof value === 'string'
    ? value
    : value?.pathname
      ? `${value.pathname}${value.search || ''}${value.hash || ''}`
      : '';

  if (!candidate.startsWith('/') || candidate.startsWith('//')) return null;

  try {
    const url = new URL(candidate, window.location.origin);
    if (url.origin !== window.location.origin || AUTH_ONLY_PATHS.has(url.pathname)) {
      return null;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function getLocationRedirect(location) {
  return normalizeInternalRedirect(location);
}

export function storePostAuthRedirect(value) {
  const path = normalizeInternalRedirect(value);
  if (!path) return null;

  try {
    sessionStorage.setItem(POST_AUTH_REDIRECT, JSON.stringify({
      path,
      createdAt: Date.now(),
    }));
  } catch {}

  return path;
}

export function readPostAuthRedirect() {
  try {
    const stored = sessionStorage.getItem(POST_AUTH_REDIRECT);
    if (!stored) return null;

    // Support redirects stored by older app versions.
    if (stored.startsWith('/')) return normalizeInternalRedirect(stored);

    const parsed = JSON.parse(stored);
    if (
      !parsed?.createdAt ||
      Date.now() - parsed.createdAt > REDIRECT_TTL_MS
    ) {
      clearPostAuthRedirect();
      return null;
    }
    return normalizeInternalRedirect(parsed.path);
  } catch {
    clearPostAuthRedirect();
    return null;
  }
}

export function clearPostAuthRedirect() {
  try {
    sessionStorage.removeItem(POST_AUTH_REDIRECT);
  } catch {}
}

export function consumePostAuthRedirect(preferredValue) {
  const redirect = normalizeInternalRedirect(preferredValue)
    || readPostAuthRedirect()
    || DEFAULT_REDIRECT;
  clearPostAuthRedirect();
  return redirect;
}

export { DEFAULT_REDIRECT as DEFAULT_AUTH_REDIRECT };
